
















import CtrlSearchCommonComponents from '@/components/common/control/CtrlSearchCommonComponents.vue';
import Vue from 'vue';

export default Vue.extend({
  name: 'ListShogTekiyo',
  components: {
    CtrlSearchCommonComponents,
  },

  props: {
    tekiyoShuruiCd: {
      type: Number,
    },
    mukoUmuFlg: {
      type: Number,
    },
  },

  data: () => ({
    headers: [
      {
        text: 'コード',
        sortable: true,
        value: 'shogakariTekiyoCd',
        width: 55,
      },
      {
        text: '名称',
        sortable: true,
        value: 'shogakariTekiyoMei',
        width: 170,
      },
    ],
    formatColName: 'shogakariTekiyoCd',
  }),
});
